<template>
  <div>
    <div class="flex items-end largeDesktop:items-center justify-between pricebookbtns w-full p-[8px] tablet:p-2.5 rounded-full bg-[#EFEFEF80]">
      <button
        class="group mobile:px-2 tablet:px-4 mobile:!py-1 transition-all duration-300 mobile:min-w-full tablet:min-w-max flex mobile:justify-between tablet:justify-center items-center gap-[6px] target:gap-2 rounded-full shadow-custom focus:!shadow-custom mobile:bg-[#BA90C6] laptop:bg-[#fff] laptop:hover:bg-[#BA90C6]"
        @click="nrgItemsClicked()">
        <span v-if="quoteDetail.partner_info.show_approved_item_text == 1"
          class="font-normal text-[12px] tablet:text-[14px] font-roboto mobile:text-[#fff] laptop:text-[#333333] laptop:group-hover:text-[#fff]">
          Select Items from {{ quoteDetail.partner_info.company_name }} approved list </span>
        <span v-else
          class="font-normal text-[14px] font-roboto mobile:text-[#fff] laptop:text-[#333333] laptop:group-hover:text-[#fff]">
          Select Items from Pricebook
        </span>
        <img src="@/assets/images/selectItems-icon.png"
          class="w-[24px] h-[24px] tablet:w-[28px] tablet:h-[28px] object-contain mobile:hidden laptop:block laptop:group-hover:hidden">
        <img src="@/assets/images/selectItems-icon-hover.png"
          class="w-[24px] h-[24px] tablet:w-[28px] tablet:h-[28px] object-contain mobile:block laptop:group-hover:block laptop:hidden">
      </button>
      <div class="mobile:hidden tablet:flex flex-wrap laptop:flex-nowrap gap-2 items-center justify-end addmanualyitems">
        <p v-if="isPartnerQuote && isShowApproved" class="mobile:m-0 laptop:mr-2 largeDesktop:mr-0 text-[12px] font-lato text-[#F67280]">
          (Not approved by {{
            quoteDetail.partner_info.company_name
          }})
        </p>
        <button
          class="group p-[5px] pr-2 transition-all duration-300 flex justify-center items-center gap-1.5 rounded-full shadow-custom focus:!shadow-custom mobile:bg-[#14C38E] laptop:bg-[#fff] laptop:hover:bg-[#14C38E]"
          @click="addItemManually()">
          <img src="@/assets/images/add-icon-green.png"
            class="w-[30px] h-[30px] object-contain mobile:hidden laptop:block laptop:group-hover:hidden">
          <img src="@/assets/images/add-icon-white.png"
            class="w-[30px] h-[30px] object-contain mobile:block laptop:group-hover:block laptop:hidden">
          <span
            class="font-normal text-[14px] font-roboto mobile:text-[#fff] laptop:text-[#333333] laptop:group-hover:text-[#fff]">
            Add Items Manually </span>
        </button>
      </div>
    </div>
    <div class="mobile:flex tablet:hidden justify-end gap-[4px] [@media(min-width:430px)]:gap-3 items-center py-3.5 addmanualyitems">
      <p v-if="isPartnerQuote && isShowApproved" class="m-0 text-[12px] font-lato text-[#F67280]">
        (Not approved by {{
          quoteDetail.partner_info.company_name
        }})
      </p>
      <button
        class="group p-[5px] pr-3 transition-all duration-300 flex justify-center items-center gap-2.5 rounded-full shadow-custom focus:!shadow-custom bg-[#fff]"
        @click="addItemManually()">
        <img src="@/assets/images/add-icon-green.png" class="w-[30px] h-[30px] object-contain">
        <span class="font-normal text-[14px] font-roboto text-[#333333]">
          Add Items Manually </span>
      </button>
    </div>
    
    <div v-if="manualItems.length > 0" class="grid grid-cols-1 gap-y-[35px] mobile:max-h-[450px] laptop:max-h-max overflow-y-auto py-3 px-2 tablet:mt-3">
      <div v-for="(items, idx) in manualItems" :key="items.value">
        <div class="relative shadow-[0_0_10px_-2px_rgba(0,0,0,0.15)] rounded-[10px] px-3 py-6 pb-3 ">
          <div class="flex items-center justify-between absolute -top-[15px] left-0 w-full px-3">
            <div v-if="isPartnerQuote && isShowApproved">
              <span v-if="(items.is_covered_by_nrg == 1 && quoteDetail.partner_info.service_type != 'maintenance') ||
                (items.service_part_id > 0 && quoteDetail.partner_info.service_type != 'maintenance') ||
                (items.is_evaluation_fee == 1 && items.is_covered_by_nrg == 1)"
                class="px-[8px] py-[5px] font-roboto text-[12px] rounded-full text-[#fff] bg-[#54B435]">
                Covered by {{ quoteDetail.partner_info.company_name }}
              </span>
              <span v-else-if="(items.is_covered_by_nrg == 2 && quoteDetail.partner_info.service_type != 'maintenance') ||
               (items.is_evaluation_fee == 1 && items.is_covered_by_nrg == 2)"
                class="px-[8px] py-[5px] font-roboto text-[12px] rounded-full text-[#fff] bg-[#54B435]">
                Partially Covered by {{ quoteDetail.partner_info.company_name }}
              </span>
              <span v-else class="px-[8px] py-[5px] font-roboto text-[12px] rounded-full text-[#fff] bg-[#F67280]">
                (Not Covered)
              </span>
            </div>
          </div>
          <div v-if="items.is_deletable" class="group absolute -top-[15px] right-2.5 shadow-[0_0_10px_-2px_rgba(0,0,0,0.15)] cursor-pointer rounded-full w-[30px] h-[30px] flex items-center justify-center transition-all duration-300 mobile:bg-[#F67280] laptop:bg-[#fff] laptop:hover:bg-[#F67280]"
            @click="deleteItemClicked(items)">
            <img src="@/assets/images/trash-icon-updated.png"
              class="w-[16px] h-[16px] object-contain mobile:hidden laptop:block laptop:group-hover:hidden">
            <img src="@/assets/images/trash-icon-white-updated.png"
              class="w-[16px] h-[16px] object-contain laptop:hidden mobile:block laptop:group-hover:block">
          </div>
          <div class="grid grid-cols-1 tablet:grid-cols-2 gap-4">
            <div>
              <label class="text-[14px] font-roboto text-[#999999]">Title</label>
              <input :id="'title_' + idx" v-model="items.title"
                :disabled="(items.is_max_markup_applicable == 1 || items.is_deletable == 0)" type="text"
                placeholder="Enter Title"
                class="form-control !h-[40px] !rounded-[10px] !text-[14px] !border-[#EFEFEF] !shadow-none disabled:!bg-[#EFEFEF] mt-1"
                @drop.prevent @dragover.prevent>
            </div>
            <div>
              <label v-if="
                items.is_deletable &&
                items.service != null &&
                items.service.is_service_fee_applicable == 1
              " class="text-[14px] font-roboto text-[#999999]">
                Part Cost
              </label>
              <label v-else-if="items.is_deletable" class="text-[14px] font-roboto text-[#999999]"> Fee (Part + Service)
              </label>
              <label v-else-if="items.is_evaluation_fee" class="text-[14px] font-roboto text-[#999999]"> Evaluation
                Fee</label>
              <div class="flex items-stretch rounded-[10px] overflow-hidden mt-1 relative h-[40px]">
                <span class="text-[20px] px-3 h-full absolute left-0 top-0 rounded-[10px] flex items-center justify-center text-[#fff] bg-[#A3AAD2]">$</span>
                
                <input v-if="items.is_evaluation_fee" :id="'price_' + idx" v-model="items.part_price" type="text"
                  placeholder="Enter Evaluation Fee" :step="0.9" inputmode="decimal" pattern="[0-9]*[.]?[0-9]*"
                  class="form-control !rounded-[10px] !text-[14px] !pl-[50px] !border-[#EFEFEF] !shadow-none focus:!border-[#ccc]"
                  @input="validateInputLimitation(idx, true)" @paste="disablePaste"
                  @keypress="isNumberLimitation($event)" @drop.prevent @dragover.prevent>
                <input v-else :id="'price_' + idx" v-model="items.part_price" type="text" :placeholder="items.service != null &&
                  items.service.is_service_fee_applicable == 1
                  ? 'Enter Part Cost'
                  : 'Enter Fee (Part + Service)'
                  " inputmode="decimal" pattern="[0-9]*[.]?[0-9]*" :step="0.9"
                  class="form-control !rounded-[10px] !text-[14px] !pl-[50px] !border-[#EFEFEF] !shadow-none focus:!border-[#ccc]"
                  @input="validateInputLimitation(idx, true)" @paste="disablePaste"
                  @keypress="isNumberLimitation($event)" @drop.prevent @dragover.prevent>
              </div>

              <span v-if="items.is_max_markup_applicable && (items?.part_price ?? 0) > items.max_allowed_price"
                class="text-[11px] text-red-500 min-h-[20px] w-full">Price
                cannot exceed
                ${{ items.max_allowed_price }}.</span>


              <label v-if="
                items.service != null &&
                items.service.is_service_fee_applicable == 1
              " class="mt-2 text-[14px] font-roboto text-[#999999]">{{
                replaceDollar(
                  items.service.service_fee_title ?? "Service Fee ($)"
                )
              }}</label>

              <div v-if="
                items.service != null &&
                items.service.is_service_fee_applicable == 1"
                class="flex items-stretch rounded-[10px] overflow-hidden mt-1 relative h-[40px]">
                <span class="text-[20px] px-3 h-full absolute left-0 top-0 rounded-[10px] flex items-center justify-center text-[#fff] bg-[#A3AAD2]">$</span>
                
                <input v-if="!items.is_evaluation_fee" :id="'service_fee_' + idx" v-model="items.service.price"
                  type="text" :placeholder="'Enter ' +
                    replaceDollar(
                      items.service.service_fee_title ?? 'Service Fee ($)'
                    )
                    " :disabled="items.service.is_service_fee_editable == 0" :step="0.9" inputmode="decimal"
                  pattern="[0-9]*[.]?[0-9]*"
                  class="form-control !rounded-[10px] !text-[14px] !pl-[50px] !border-[#EFEFEF] !shadow-none focus:!border-[#ccc]"
                  @input="validateInputLimitation(idx, false)" @paste="disablePaste" @drop.prevent @dragover.prevent
                  @keypress="isNumberLimitation($event)">
                <input v-else :id="'service_fee_' + idx" v-model="items.service.price"
                  placeholder="Enter Evaluation Fee" type="text"
                  class="form-control !rounded-[10px] !text-[14px] !pl-[50px] !border-[#EFEFEF] !shadow-none focus:!border-[#ccc]"
                  :value="items.part_price" inputmode="decimal" pattern="[0-9]*[.]?[0-9]*"
                  :disabled="items.service.is_service_fee_editable == 0" :step="0.9"
                  @input="validateInputLimitation(idx, false)" @paste="disablePaste" @drop.prevent @dragover.prevent
                  @keypress="isNumberLimitation($event)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isPartnerQuote"
      class="relative shadow-[0_0_10px_-2px_rgba(0,0,0,0.15)] rounded-[10px] px-3 py-[16px] ml-[8px] mr-[1rem] mt-2 col-span-1 laptop:col-span-2">
      <label class="text-[16px] font-roboto text-[#999999]"> {{ quoteDetail?.discount?.title || "Discount" }}</label>
      <div class="flex items-stretch rounded-[10px] overflow-hidden mt-1 relative h-[40px]">
        <span class="text-[20px] px-3 h-full absolute left-0 top-0 rounded-[10px] flex items-center justify-center text-[#fff] bg-[#A3AAD2]">$</span>
        <input v-model="discount"
          class="form-control !rounded-[10px] !text-[14px] !pl-[50px] !border-[#EFEFEF] !shadow-none focus:!border-[#ccc]"
          placeholder="Enter Discount" :step="0.9" inputmode="decimal" pattern="[0-9]*[.]?[0-9]*"
          @input="validateInputLimitationDiscount(discount)" @paste="disablePaste" @drop.prevent @dragover.prevent
          @keypress="isNumberLimitation($event)">
      </div>
    </div>


    <div class="text-center mt-3 laptop:mt-5">
      <button class="group/finalize flex items-center mx-auto gap-2 px-[28px] py-2 rounded-full transition duration-300 border-1 border-[#29C6CD] hover:bg-[#29C6CD] mobile:bg-[#29C6CD] laptop:bg-[#fff]
        disabled:border-[#CCCCCC] disabled:bg-transparent disabled:text-[#CCCCCC] disabled:cursor-not-allowed"
        :disabled="!((manualItems ?? []).length > 0)" @click="finalizeQuoteClicked()">
        <span
          class="text-[16px] font-roboto mobile:text-[#fff] laptop:text-[#29C6CD] group-hover/finalize:text-[#fff] group-disabled/finalize:text-[#CCCCCC]">Finalize
          Quote</span>
      </button>
    </div>

    <!-- Modal -->
    <div id="exampleModal" ref="modal" class="modal fade modal-lg" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <NrgItems :list="manualItems" :open-modal="openModal" @event="nrgItemsCallback" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NrgItems from "@/components/nrg_items/NrgItems.vue";
import { Modal } from "bootstrap";
import { globals } from "../../main";
import { useToast } from "vue-toastification";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
const toast = useToast();

export default {
  components: {
    NrgItems,
  },
  // props: ['no_of_units'],

  data() {
    return {
      modal: null,
      manualItems: [],
      postItems: [],
      openModal: false,
      discount: '',
      isApiCalled: false,
      no_of_units: -1
    };
  },
  computed: {
    ...mapGetters(["quoteItems", "storeQuoteData", "storeQuoteItems", "quoteDetail"]),

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    },

    isShowApproved() {
      return this.quoteDetail?.partner_info?.show_approved_item_text == 1 || false
    },
  },

  watch: {

    quoteItems: function () {
      this.isApiCalled = true
      this.manualItems = this.quoteItems
      this.discount = Math.abs(this.quoteDetail?.discount?.price)
    },

    // no_of_units: function () {

    //   // this.getItems()
    // },

    storeQuoteItems: function () {
      const quote = Object.assign({}, this.quoteDetail);
      quote.items = this.manualItems;
      this.updateQuoteItems(quote);
      this.setCommponent("QuoteSummary");
    },
  },

  mounted() {
  },

  methods: {
    ...mapActions(["getQuoteItems", "getQuoteItemsPartner", "postQuoteData", "setCommponent", "updateQuoteItems"]),

    setUnits(no_of_units) {
      this.no_of_units = no_of_units
      this.getItems()
    },

    getItems() {
      globals.$loader.show();
      if (this.isPartnerQuote) {
        this.getQuoteItemsPartner({
          manual_quote_id: this.$route.params.id,
          number_of_units: this.no_of_units
        });
      } else {
        this.getQuoteItems({
          manual_quote_id: this.$route.params.id,
          number_of_units: this.no_of_units
        });
      }
    },

    validateInputLimitation(idx, isPartPrice) {
      let regex = /^\d{0,5}(\.\d{0,2})?$/;
      if (isPartPrice) {
        if (!regex.test(this.manualItems[idx].part_price)) {
          this.manualItems[idx].part_price = this.manualItems[
            idx
          ].part_price.slice(0, -1);
        }
      } else {
        if (!regex.test(this.manualItems[idx].service.price)) {
          this.manualItems[idx].service.price = this.manualItems[
            idx
          ].service.price.slice(0, -1);
        }
      }
    },

    validateInputLimitationDiscount() {
      let regex = /^\d{0,5}(\.\d{0,2})?$/;
      if (!regex.test(this.discount)) {
        this.discount = this.discount.slice(0, -1);
      }
    },

    isNumberLimitation(evt) {
      evt = evt || window.event;
      const charCode = evt.which || evt.keyCode;
      const inputElement = evt.target;
      const value = inputElement.value;
      const cursorPos = inputElement.selectionStart; // Track cursor position
      // Allow control keys
      if (charCode === 8 || charCode === 46 || charCode === 9) {
        return true;
      }
      // Restrict length to 4 characters before the decimal
      const parts = value.split('.');
      if (parts.length > 1) {
        if (parts[0].length >= 4 && cursorPos <= parts[0].length) {
          evt.preventDefault();
          return false;
        }
        // Allow up to 2 digits after the decimal point
        if (parts[1].length >= 2) {
          evt.preventDefault();
          return false;
        }
      } else if (parts[0].length >= 5 && cursorPos <= parts[0].length) {
        evt.preventDefault();
        return false;
      }
      // Allow only numeric characters and single decimal point
      if ((charCode >= 48 && charCode <= 57) || charCode === 46) {
        if (charCode === 46 && value.indexOf('.') !== -1) {
          evt.preventDefault();
          return false;
        }
        return true;
      }
      evt.preventDefault();
      return false;
    },


    validateInput(idx, isPartPrice) {
      let regex = /^\d{0,4}(\.\d{0,2})?$/;
      if (isPartPrice) {
        if (!regex.test(this.manualItems[idx].part_price)) {
          this.manualItems[idx].part_price = this.manualItems[
            idx
          ].part_price.slice(0, -1);
        }
      } else {
        if (!regex.test(this.manualItems[idx].service.price)) {
          this.manualItems[idx].service.price = this.manualItems[
            idx
          ].service.price.slice(0, -1);
        }
      }
    },


    isNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which || evt.keyCode;
      const inputElement = evt.target;
      const value = inputElement.value;
      const cursorPos = inputElement.selectionStart; // Track cursor position
      // Allow control keys
      if (charCode === 8 || charCode === 46 || charCode === 9) {
        return true;
      }
      // Restrict length to 4 characters before the decimal
      const parts = value.split('.');
      if (parts.length > 1) {
        if (parts[0].length >= 4 && cursorPos <= parts[0].length) {
          evt.preventDefault();
          return false;
        }
        // Allow up to 2 digits after the decimal point
        if (parts[1].length >= 2) {
          evt.preventDefault();
          return false;
        }
      } else if (parts[0].length >= 4 && cursorPos <= parts[0].length) {
        evt.preventDefault();
        return false;
      }
      // Allow only numeric characters and single decimal point
      if ((charCode >= 48 && charCode <= 57) || charCode === 46) {
        if (charCode === 46 && value.indexOf('.') !== -1) {
          evt.preventDefault();
          return false;
        }
        return true;
      }
      evt.preventDefault();
      return false;
    },


    replaceDollar(str) {
      return str.replace("($)", "");
    },

    disablePaste(event) {
      event.preventDefault();
    },

    deleteItemClicked(item) {
      if (item.part_price.length > 0 || item.title.length > 0) {
        this.$dialog.show({
          title: "Delete Item",
          text: "Are you sure you want to delete this item?",
          // image: "pop-req-img.png",
          // we are passing callback method for our confirm button
          onConfirm: () => {
            var index = this.manualItems.indexOf(item);
            if (index !== -1) {
              this.manualItems.splice(index, 1);
            }
          },
        });
      } else {
        var index = this.manualItems.indexOf(item);
        if (index !== -1) {
          this.manualItems.splice(index, 1);
        }
      }
    },

    nrgItemsClicked() {
      this.openModal = new Date();
      this.modal = new Modal(this.$refs.modal);
      this.modal.show();
      disableScroll()
      this.adjustConsumerModalHeight();
    },
    adjustConsumerModalHeight() {
      const modalContent = this.$refs.modal?.querySelector('.responsiveOreitationConsumerHeightAdjust');
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 400) {
          maxHeight = vh * 0.3 - 40;
        } else if (vw < 750) {
          maxHeight = vh * 0.35 - 40;
        } else if (vw < 1440) {
          maxHeight = vh * 0.35 - 70;
        } else {
          maxHeight = vh * 0.35 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },
    nrgItemsCallback(data) {
      enableScroll()
      this.modal.hide();
      data.forEach((value) => {
        let check = this.manualItems.some(
          (vendor) => vendor.service_part_id == value.service_part_id
        );
        if (!check) {
          value.is_deletable = 1
          this.manualItems.push(value);
        }
      });
    },

    addItemManually() {
      if (this.isValid(false)) {
        const newFirstElement = {
          title: "",
          part_price: "",
          is_deletable: 1,
          service_part_id: -1,
          service: {
            price: 0,
            service_fee_title: "Service Fee ($)",
            is_service_fee_applicable: 0,
            is_service_fee_editable: 0,
          },
        };
        this.manualItems.push(newFirstElement)
        //  this.manualItems = [newFirstElement].concat(this.manualItems);
        // if (this.isPartnerQuote) {
        //   this.manualItems.splice(this.no_of_units, 0, newFirstElement);
        // } else {
        //   this.manualItems.splice(0, 0, newFirstElement);
        // }

      }
    },

    isValid(isCheckDiscount) {
      let res = true;
      this.postItems = [];
      for (let i = 0; i < this.manualItems.length; i++) {
        let eachItem = this.manualItems[i];


        if (this.isEmpty(eachItem.title)) {
          toast.error("Title field is required.");
          res = false;
          return;
        } else if (this.isEmpty(eachItem.part_price)) {
          let str =
            eachItem.service != null &&
              eachItem.service.is_service_fee_applicable == 1
              ? "Part Cost"
              : "Fee (Part + Service)";


          if (eachItem.is_evaluation_fee) {
            toast.error("Evaluation fee field is required.");
          }
          else {
            toast.error(str + " field is required.");
          }
          res = false;
          return;
        } else if (
          eachItem.service.is_service_fee_applicable == 1 &&
          this.isEmpty(eachItem.service.price)
        ) {
          toast.error("Service fee field is required.");
          res = false;
          return;
        }

        if (eachItem.is_max_markup_applicable &&
          eachItem.part_price > eachItem.max_allowed_price) {
          toast.error("Please fix price errors before saving.");
          res = false;
          return;
        }

        this.postItems.push(this.getFomattedObject(eachItem));
      }

      if (!this.isPartnerQuote && isCheckDiscount) {
        const total = this.getTotalPartPrice();
        if (this.isEmpty(this.discount)) {
          toast.error("Discount field is required.");
          res = false;
        } else if (this.discount > total) {
          toast.error("Discount cannot exceed the total amount.");
          res = false;
        }

      }
      return res;
    },

    getTotalPartPrice() {
      return this.manualItems.reduce(
        (sum, item) => sum + parseFloat(item.part_price || 0),
        0
      );
    },

    getFomattedObject(data) {
      let obj = {
        service_part_id: data.service_part_id ?? -1,
        service_fee: data.service != null ? data.service.price : 0,
        part_price: data.part_price ?? 0,
        title: data.title ?? "",
        is_evaluation_fee: data.is_evaluation_fee ?? 0,
        max_allowed_price : data.max_allowed_price
      };
      return obj;
    },

    finalizeQuoteClicked() {


      if (this.isValid(true)) {
        if (this.isPartnerQuote) {
          this.postQuoteData({
            url: "/manual-quote/partner/items/collect",
            params: {
              number_of_units: this.no_of_units,
              manual_quote_id: this.quoteDetail.id,
              items: JSON.stringify(this.postItems),
            }
          });
        } else {
          this.postQuoteData({
            url: "/manual-quote/items/collect",
            params: {
              discount: `-${this.discount}`,
              number_of_units: this.no_of_units,
              manual_quote_id: this.quoteDetail.id,
              items: JSON.stringify(this.postItems),
            }
          });
        }

      }
    },

    isEmpty(value) {
      return (
        value == null ||
        (value + "").trim().length === 0 ||
        (value.constructor === Object && Object.keys(value).length === 0)
      );
    },
  },
};
</script>

<style>
.buttonsGroup {
  display: flex;
  justify-content: center;
}

.buttonsGroup .main-button {
  background: #fe5000;
  border-radius: 8px;
  box-shadow: 0 4px 5px #999;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 10px 30px;
  margin: 0 20px;
}

.buttonsGroup .main-button:hover {
  background-color: #092e87;
  color: #fff;
}

.quoteBox-wrapp {
  padding: 15px;
  border: 2px solid #999;
  border-radius: 10px;
}

.qoutationBox-fixed {
  padding: 10px;
  border-radius: 8px;
  background-color: #d9d9d9;
  box-shadow: 0 3px 5px #0000004f;
  height: 100%;
  /* display: flex; */
  align-items: center;
  min-height: 155px;
}

.qoutationBox {
  margin-bottom: 20px;
  min-height: 180px;
  /* height: 100%; */
}

.qoutationBox-fixed h3,
.qoutationBox h3 {
  font-size: 20px;
  color: #092e87;
  font-weight: normal;
  margin-bottom: 15px;
}

.qoutationBox h3 {
  margin-bottom: 23px;
}

.qoutationBox small {
  margin-left: 18px;
  font-size: 12px;
  color: #092e87;
  font-weight: 500;
}

.qoutationBox label {
  margin-left: 18px;
  font-size: 14px;
  color: #fe5000;
  font-weight: 500;
}

.qoutationBox-fixed h2 {
  font-size: 55px;
  color: #fe5000;
  font-weight: 500;
  display: block;
}

.qoutationBox-fixed h2 span {
  font-size: 18px;
  position: relative;
  top: -15px;
}

.qoutationBox {
  padding: 10px;
  border-radius: 8px;
  background-color: #d9d9d9;
  box-shadow: 0 3px 5px #0000004f;
  padding-right: 25px;
  position: relative;
}

.quoteField {
  /* display: flex; */
}

.quoteField span {
  /* margin-right: 4px;
  color: #fe5000;
  font-size: 18px; */
}

.quoteField .form-control {
  /* height: 40px;
  font-size: 22px; */
}

.title-field .form-control {
  margin-left: 15px;
  width: calc(100% - 15px);
  margin-bottom: 5px;
}

.crossBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 99;
  cursor: pointer;
}

@media screen and (max-width: 767px) {
  .buttonsGroup .main-button {
    font-size: 14px;
    padding: 10px 11px;
    margin: 0 6px;
  }

  .buttonsGroup .main-button {
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 440px) {

  .pricebookbtns button,
  .pricebookbtns .addmanualyitems {
    width: 100%;
  }

  .pricebookbtns {
    flex-direction: column;
    gap: 10px;
  }
}

@media screen and (max-width: 405px) {
  .addmanualyitems {
    flex-direction: column-reverse;
    gap: 10px !important;
  }

  .pricebookbtns button span {
    font-size: 12.5px !important;
  }
}
</style>
